import { MoovStepDTO } from "./moovStepDTO";

export class MoovDefinitionDTO{
    public id? : number;
    public name! : string;
    public description! : string;
    public integratesWith?:string;
    public steps : MoovStepDTO[] = []; //protocol for each field on how to transform
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : string;
    public deleted : boolean = false;
    public outdated : boolean = false;
    public ownedByEntityId? : number;
    public ownerEntityType? : string;
    public usageType? : number;
    public integrationType? : number;
    public usagePrice? : number;
    public billingBucketId? : number;
    public presets? : string;
    public wizardSessionId? : number;

    constructor(){
    }

}